import React from 'react';
import './Contact.css';

function Contact() {
    return (
        <div className="contact">
            <h1>Contact</h1>
            <div>
                <div className="contact__content">
                    <h3>GENERAL INFORMATION:</h3>
                    <div className="contact__p">
                        <label>Morning Ideas s.r.o.</label>
                        <small>Klincová 35</small>
                        <small>Klincová 35Bratislava 821 08</small>
                        <small>Slovakia</small>
                    </div>
                </div>
                <div className="contact__content">
                    <h3>CUSTOMER SUPPORT:</h3>
                    <div className="contact__p">
                        <label>info@itouch.com</label>
                        <small>Call: +421 2 2063 3245</small>
                        <h4>Monday through Friday</h4>
                        <small>08:30AM to 02:30PM</small>
                    </div>
                </div>
                <div className="contact__content contact__contentlast">
                    <h3>WARRANTY HANDLING:</h3>
                    <div className="contact__p">
                        <p>Regarding correct postal address for returning the product and service after purchase please contact our customer service on:</p>
                        <label>warranty@toycity.com</label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact;
